import { environment } from '$environments/environment';
import { Payment } from '$types';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  constructor(private readonly http: HttpClient) { }

  getSherlockPayment(id_post: string):Observable<Payment> {
    const id_client = '0x',
      paypageUrl = `${environment.apiUrl}/app/rest/sherlock-paypage`

      return this.askPayPage(paypageUrl, id_post, id_client);
  }
  getSherlockRenewal(id_post: string):Observable<Payment> {
    const id_client = '0x',
      paypageUrl = `${environment.apiUrl}/app/rest/sherlock-paypage/renewal`

    return this.askPayPage(paypageUrl, id_post, id_client);
  }

  private askPayPage(paypageUrl: string, id_post: string, id_client: string):Observable<Payment> {
    return this.http.post<Payment>(
      paypageUrl, {
      currentUrl: '',
      returnContext: [
        'post_renewal',
        id_post,
        id_client,
        window.origin + '/posts',
      ].join('&'),
    });
  }
}
